<template>
    <router-link :to="{ name: 'inbox' }" data-testid="inbox-link">
        <div class="relative">
            <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M18 16C18 15.4124 17.7419 14.4247 16.8955 13.585C16.0696 12.7656 14.5929 12 12 12C9.40714 12 7.93042 12.7656 7.10449 13.585C6.25805 14.4247 6 15.4124 6 16V22.4141L5 23.4141V24H19V23.4141L18 22.4141V16ZM10 28H14V26H10V28ZM20 21.5859L21 22.5859V26H16V30H8V26H3V22.5859L4 21.5859V16C4 14.921 4.44189 13.4086 5.69531 12.165C6.9694 10.9011 8.99295 10 12 10C15.0071 10 17.0306 10.9011 18.3047 12.165C19.5581 13.4086 20 14.921 20 16V21.5859Z"
                    fill="white"
                />
            </svg>
            <span
                v-if="authStore.totalUnreadCount > 0"
                class="border-bg absolute top-0 right-0 flex h-5 min-w-5 items-center justify-center rounded-[18px] border bg-[#FF2C2C] px-1 text-xs leading-[14px] font-bold tracking-[0.25px] text-white"
            >
                {{ authStore.totalUnreadCount > 99 ? '99+' : authStore.totalUnreadCount }}
            </span>
        </div>
    </router-link>
</template>

<script>
import { mapStores } from 'pinia'
import { useAuthStore } from '@/stores/auth.js'

export default {
    name: 'InboxLink',
    computed: {
        ...mapStores(useAuthStore),
    },
}
</script>
